import { disableScroll, enableScroll } from '../../functions/scroll-lock'

const $ = window.jQuery

$('.c-modal').on('show.bs.modal', function() {
    disableScroll('bs-modal')
})

$('.c-modal').on('hidden.bs.modal', function() {
    enableScroll('bs-modal')
})
